enum TaxiCorporationBillingType {
  PUB_RAILY_2_TAXI = "PUB_RAILY_2_TAXI",
  PRIV_CARGO_2_TAXI = "PRIV_CARGO_2_TAXI",
  PRIV_TAXI_2_RAILY = "PRIV_TAXI_2_RAILY",
}

export default TaxiCorporationBillingType;
